import React, { useState, useEffect } from "react";
import {
  Button, Card, CardBody, CardTitle, Col, Container, Form, Input, Label, Row, Nav, NavItem, NavLink, TabContent, TabPane
} from "reactstrap";
import classnames from "classnames";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useFormik } from "formik";
import axios from "axios";
import toastr from "toastr";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Dropzone from 'react-dropzone-uploader';
import { Base64 } from 'js-base64';

const API_BASE_URL = "https://tazelyapi.stechomeyazilim.info";
const ABOUT_ENDPOINT = `${API_BASE_URL}/About`; 
const IMAGE_BASE_URL = 'https://megasubdomain.stechomeyazilim.info/';

const AboutManagement = () => {
  const [activeTab, setActiveTab] = useState("1");
  const [aboutData, setAboutData] = useState(null);
  const [getImage, setImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // Editor State'leri (DB'deki varbinary alanlar için)
  const [htmlLong, setHtmlLong] = useState("");
  const [htmlLongEn, setHtmlLongEn] = useState("");
  const [htmlLongAr, setHtmlLongAr] = useState("");
  
  const [htmlPrivacy, setHtmlPrivacy] = useState("");
  const [htmlPrivacyEn, setHtmlPrivacyEn] = useState("");
  const [htmlPrivacyAr] = useState(""); // Şemanızda varsa ekleyin

  const fetchAboutData = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(ABOUT_ENDPOINT);
      const data = response.data.value ? response.data.value[0] : response.data[0];

      if (data) {
        setAboutData(data);
        setImage(data.Video);
        // Base64 Decode işlemleri
        setHtmlLong(data.About_Desc ? Base64.decode(data.About_Desc) : "");
        setHtmlLongEn(data.About_Desc_En ? Base64.decode(data.About_Desc_En) : "");
        setHtmlLongAr(data.About_Desc_Ar ? Base64.decode(data.About_Desc_Ar) : "");
        
        setHtmlPrivacy(data.About_Privacy ? Base64.decode(data.About_Privacy) : "");
        setHtmlPrivacyEn(data.About_Privacy_En ? Base64.decode(data.About_Privacy_En) : "");
      }
      setIsLoading(false);
    } catch (error) {
      toastr.error("Veriler çekilemedi.");
      setIsLoading(false);
    }
  };

  useEffect(() => { fetchAboutData(); }, []);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      CompanyName: aboutData?.CompanyName || '',
      PhoneNumber: aboutData?.PhoneNumber || '',
      Mail: aboutData?.Mail || '',
      Address: aboutData?.Address || '',
      Address_En: aboutData?.Address_En || '',
      Address_Ar: aboutData?.Address_Ar || '',
      Min_CartPrice: aboutData?.Min_CartPrice || 0,
      // Saatler (DB Kolon isimleri: Order_StartTime, Order_EndTime)
      Order_StartTime: aboutData?.Order_StartTime || '09:00',
      Order_EndTime: aboutData?.Order_EndTime || '22:00',
      IsOrderTimeActive: aboutData?.IsOrderTimeActive || false,
    },
    onSubmit: async (values) => {
      setIsLoading(true);
      
      // Şemadaki kolon isimleriyle birebir eşlenmiş payload
      const payload = {
        CompanyName: values.CompanyName,
        PhoneNumber: values.PhoneNumber,
        Mail: values.Mail,
        Address: values.Address,
        Address_En: values.Address_En,
        Address_Ar: values.Address_Ar,
        Min_CartPrice: parseFloat(values.Min_CartPrice),
        Video: getImage, // Logo görseli
        // Saatler
        Order_StartTime: values.Order_StartTime,
        Order_EndTime: values.Order_EndTime,
        IsOrderTimeActive: values.IsOrderTimeActive,
        // Zengin Metinler (Base64)
        About_Desc: Base64.encode(htmlLong),
        About_Desc_En: Base64.encode(htmlLongEn),
        About_Desc_Ar: Base64.encode(htmlLongAr),
        About_Privacy: Base64.encode(htmlPrivacy),
        About_Privacy_En: Base64.encode(htmlPrivacyEn)
      };

      try {
        // Hata aldığınız PATCH isteği
        await axios.patch(`${ABOUT_ENDPOINT}(${aboutData.ID})`, payload);
        toastr.success("Bilgiler başarıyla güncellendi.");
      } catch (error) {
        console.error("Patch Error Details:", error.response?.data || error.message);
        toastr.error("Güncelleme sırasında bir hata oluştu (400 Bad Request).");
      } finally {
        setIsLoading(false);
      }
    },
  });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="Firma Ayarları" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <Form onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); }}>
                    
                    <Row>
                      <Col lg={8}>
                        <CardTitle className="mb-4">Genel Bilgiler</CardTitle>
                        <Row>
                          <Col md={6}><div className="mb-3"><Label>Firma Adı</Label><Input name="CompanyName" type="text" onChange={validation.handleChange} value={validation.values.CompanyName} /></div></Col>
                          <Col md={6}><div className="mb-3"><Label>Telefon</Label><Input name="PhoneNumber" type="text" onChange={validation.handleChange} value={validation.values.PhoneNumber} /></div></Col>
                          <Col md={6}><div className="mb-3"><Label>E-Posta</Label><Input name="Mail" type="email" onChange={validation.handleChange} value={validation.values.Mail} /></div></Col>
                          <Col md={6}><div className="mb-3"><Label>Min. Sepet Tutarı</Label><Input name="Min_CartPrice" type="number" onChange={validation.handleChange} value={validation.values.Min_CartPrice} /></div></Col>
                        </Row>
                      </Col>

                      <Col lg={4} className="border-start">
                        <CardTitle className="mb-4">Sipariş Saat Ayarları</CardTitle>
                        <div className="p-3 bg-light rounded">
                          <Row>
                            <Col md={6}>
                              <div className="mb-3">
                                <Label>Başlangıç</Label>
                                <Input name="Order_StartTime" type="time" onChange={validation.handleChange} value={validation.values.Order_StartTime} />
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="mb-3">
                                <Label>Bitiş</Label>
                                <Input name="Order_EndTime" type="time" onChange={validation.handleChange} value={validation.values.Order_EndTime} />
                              </div>
                            </Col>
                          </Row>
                          <div className="form-check form-switch mb-2">
                            <input 
                              type="checkbox" className="form-check-input" id="timeActive" 
                              checked={validation.values.IsOrderTimeActive} 
                              onChange={() => validation.setFieldValue("IsOrderTimeActive", !validation.values.IsOrderTimeActive)} 
                            />
                            <Label className="form-check-label" htmlFor="timeActive">Saat Kontrolü Aktif mi?</Label>
                          </div>
                        </div>
                      </Col>
                    </Row>

                    <hr className="my-4" />

                    <Nav tabs className="nav-tabs-custom nav-justified">
                      <NavItem><NavLink className={classnames({ active: activeTab === "1" })} onClick={() => setActiveTab("1")}>Türkçe</NavLink></NavItem>
                      <NavItem><NavLink className={classnames({ active: activeTab === "2" })} onClick={() => setActiveTab("2")}>English</NavLink></NavItem>
                      <NavItem><NavLink className={classnames({ active: activeTab === "3" })} onClick={() => setActiveTab("3")}>العربية</NavLink></NavItem>
                    </Nav>

                    <TabContent activeTab={activeTab} className="p-3">
                      <TabPane tabId="1">
                         <div className="mb-3"><Label>Adres (TR)</Label><Input name="Address" type="textarea" rows="2" onChange={validation.handleChange} value={validation.values.Address} /></div>
                         <Label className="fw-bold">Hakkımızda (TR)</Label>
                         <CKEditor editor={ClassicEditor} data={htmlLong} onChange={(e, ed) => setHtmlLong(ed.getData())} />
                      </TabPane>
                      <TabPane tabId="2">
                         <div className="mb-3"><Label>Address (EN)</Label><Input name="Address_En" type="textarea" rows="2" onChange={validation.handleChange} value={validation.values.Address_En} /></div>
                         <Label className="fw-bold">About Us (EN)</Label>
                         <CKEditor editor={ClassicEditor} data={htmlLongEn} onChange={(e, ed) => setHtmlLongEn(ed.getData())} />
                      </TabPane>
                      <TabPane tabId="3">
                         <div className="mb-3 text-end"><Label>العنوان (AR)</Label><Input dir="rtl" name="Address_Ar" type="textarea" rows="2" onChange={validation.handleChange} value={validation.values.Address_Ar} /></div>
                         <Label className="fw-bold">من نحن (AR)</Label>
                         <CKEditor editor={ClassicEditor} data={htmlLongAr} onChange={(e, ed) => setHtmlLongAr(ed.getData())} />
                      </TabPane>
                    </TabContent>

                    <div className="text-end mt-4">
                      <Button type="submit" color="primary" className="btn-lg w-md" disabled={isLoading}>
                        {isLoading ? "Güncelleniyor..." : "Bilgileri Güncelle"}
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AboutManagement;